import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import deleteAxpoCounterInvoice from "../http/deleteAxpoCounterInvoice";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const useDeleteAxpoCounterInvoice = () => {
  const queryClient = useQueryClient();
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  return useMutation(
    async (pairingId: string) =>
      deleteAxpoCounterInvoice(
        await getAuthTokenBlocking(getToken, relogin),
        pairingId
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["axpo-counter-invoices"]);
      },
    }
  );
};

export default useDeleteAxpoCounterInvoice;
